import { render, staticRenderFns } from "./StudentCourseHistory.vue?vue&type=template&id=6c717d7c&scoped=true"
import script from "./StudentCourseHistory.vue?vue&type=script&lang=ts"
export * from "./StudentCourseHistory.vue?vue&type=script&lang=ts"
import style0 from "./StudentCourseHistory.vue?vue&type=style&index=0&id=6c717d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c717d7c",
  null
  
)

export default component.exports